import BaseSource, { AVAILABLE_COLLECTION_TYPES } from 'sources/baseSource';
import Address from 'types/Address';
import AddressSourceType from 'sources/sourceTypes/Address';
import * as mapper from 'sources/mapper/Address';

class AddressSource extends BaseSource<Address, AddressSourceType, {}> {
  public ObjectURL = 'addresses' as AVAILABLE_COLLECTION_TYPES;

  public toSource = mapper.toSource;

  public toType = mapper.toType;
}

const addressSource = new AddressSource();

export default addressSource;
